<template>
    <div id="mapSelector" v-bind:class="mapClass">
            <div id="heatmapButton" @click="selectMap('heatmap')" @mouseover="hoverHeatmap" @mouseout="mapClassReset">Heat Map</div>
            <div id="bivariateButton" @click="selectMap('bivariate')" @mouseover="hoverBivariate" @mouseout="mapClassReset">Bivariate</div>
            </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState(['selectedMap', 'selectedMapClass'])
    },
    methods: {
      selectMap(value) {
        this.$store.dispatch('selectMap', value);
      },
      hoverHeatmap() {
        this.mapClass = this.$store.state.selectedMapClass + " heatmapHover";
      },
      hoverBivariate() {
        this.mapClass = this.$store.state.selectedMapClass + " bivariateHover";
      },
      mapClassReset() {
        this.mapClass = this.$store.state.selectedMapClass;
      }
    },
    data() {
      return {
        mapClass: this.$store.state.selectedMapClass
      }
    }
};
</script>